// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  API: '',
  offShoreAPI:'https://6ny24her6j.execute-api.us-west-1.amazonaws.com/v1',
  devShoreAPI:'https://6ny24her6j.execute-api.us-west-1.amazonaws.com/v1',
  uatShoreAPI:'https://hcj67edzde.execute-api.us-west-1.amazonaws.com/v1',
  prodShoreAPI:'https://t7t2gpx1x1.execute-api.us-west-1.amazonaws.com/v1',
  signUpCreate:'signup/create',
  sendRegistrationsms: 'send/registrationsms',
  requestRead: 'signup/request/read',
  submit:'signup/submit',

  ValidateAPIDev:"https://ibvq8rb2i5.execute-api.us-west-1.amazonaws.com/v1/",
  ValidateAPIUAT:"https://7py8fahnf3.execute-api.us-west-1.amazonaws.com/v1/",
  ValidateAPIProd:"https://llz1npmgm7.execute-api.us-west-1.amazonaws.com/v1/",

  loyaltySignupSubmit:'https://qyt43jq296.execute-api.us-west-1.amazonaws.com/v1/submit', 
  loyaltySignupSubmit_UAT:'https://gpnk09mocd.execute-api.us-west-1.amazonaws.com/v1/submit',
  loyaltySignupSubmit_DEV:'https://kjzzq43s60.execute-api.us-west-1.amazonaws.com/v1/submit'
  
}; 
